import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import Btn from "../components/Btn/Btn";
import { Link } from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

const Scenery = () => {
  const show = true;
  if (show) {
  return (
    <React.Fragment>
      <SEO title="Scenery | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content2">
          <div className="ch-lang-en">
            <Link className="btn btn-primary" to={process.env.PUBLIC_URL + "/scenery_zn"}>简体中文</Link>
          </div>
          <div className="space-50"></div>
          <h2>Attractions in Beijing</h2>
          <p align="justify">
            <b>
            Beijing, the capital of China, is a city that seamlessly blends ancient history with modern innovation. As one of the most populous cities in the world, it serves as the political, cultural, and educational heart of the country. Beijing is renowned for its rich heritage, iconic landmarks, and a unique mix of traditional and contemporary architecture, ranging from ancient temples and imperial palaces to cutting-edge skyscrapers. 
            <br></br> 
            Beijing is home to some of the world&apos;s most famous historical sites, including the Great Wall of China, a UNESCO World Heritage Site that stretches across the northern part of the country, and the Forbidden City, the former imperial palace that offers a glimpse into China&apos;s royal past. Another must-visit site is the Temple of Heaven, where emperors once performed rituals to pray for good harvests. 
            <br></br> 
            The city&apos;s culinary scene is a delight for food enthusiasts, featuring a wide variety of authentic Chinese dishes such as Peking duck, dumplings, and hotpot. Whether you&apos;re strolling through the historic hutongs (narrow alleys) or exploring the vibrant shopping districts like Wangfujing and Sanlitun, Beijing offers a dynamic and unforgettable experience for all visitors.         
            </b>
          </p>

          <li>
            <a href="#Peking University">Peking University</a>
          </li>
          <li>
            <a href="#The Great Wall of China">The Great Wall of China</a>
          </li>
          <li>
            <a href="#The Forbidden City">The Forbidden City</a>
          </li>
          <li>
            <a href="#Monument to the Peoples Heroes">Monument to the People&apos;s Heroes</a>
          </li>
          <li>
            <a href="#Tiananmen Square">Tiananmen Square </a>
          </li>
          <li>
            <a href="#The Temple of Heaven">The Temple of Heaven</a>
          </li>
          <li>
            <a href="#The Summer Palace">The Summer Palace</a>
          </li>
          <li>
            <a href="#The Old Summer Palace">The Old Summer Palace</a>
          </li>
          <li>
            <a href="#Yonghe Temple">Yonghe Temple</a>
          </li>

          <br />

          <hr></hr>
          <h4 id="Peking University">Peking University</h4>
          <p align="justify">
Peking University, one of the most prestigious and iconic institutions in China, is located in the heart of Beijing. Established in 1898, it has a rich history of over a century, serving as a cradle of modern Chinese education and a beacon of intellectual and cultural development. The university’s beautiful campus, with its traditional Chinese architecture and serene landscapes, offers a peaceful retreat from the bustling city and a glimpse into China’s academic heritage.          </p>
          <p>
            <img
              src="./images/beijing/beijingdaxue.jpg"
              alt="Peking University"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Great Wall of China">The Great Wall of China</h4>
          <p align="justify">
            The Great Wall of China, one of the most iconic landmarks in the world, stretches over 13,000 miles across northern China. Built over centuries to protect against invasions, it offers breathtaking views and a glimpse into China&apos;s ancient history. Visiting the Great Wall is a must for anyone traveling to Beijing, as it symbolizes the country&apos;s resilience and architectural ingenuity.          </p>
          <p>
            <img
              src="./images/beijing/changcheng.jpg"
              alt="The Great Wall of China"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Forbidden City">The Forbidden City</h4>
          <p align="justify">
            The Forbidden City, located in the heart of Beijing, served as the imperial palace for 24 emperors during the Ming and Qing dynasties. This vast complex, with its intricate architecture and beautiful courtyards, is a UNESCO World Heritage Site. It houses countless artifacts and offers a deep dive into China&apos;s royal history and culture.
          </p>
          <p>
            <img
              src="./images/beijing/gugong.png"
              alt="The Forbidden City"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Monument to the Peoples Heroes">Monument to the People&apos;s Heroes</h4>
          <p align="justify">
The Monument to the People&apos;s Heroes stands in Tiananmen Square, commemorating those who sacrificed their lives for the revolutionary struggles of China. This towering obelisk is a symbol of national pride and resilience, surrounded by significant historical landmarks. It serves as a reminder of China&apos;s journey towards modernization and independence.
          </p>
          <p>
            <img
              src="./images/beijing/renminyingxiong.jpg"
              alt="Monument to the People's Heroes"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="Tiananmen Square">Tiananmen Square</h4>
          <p align="justify">
            Tiananmen Square, one of the largest public squares in the world, is a central landmark in Beijing. It has been the site of many important historical events and is surrounded by significant buildings like the Great Hall of the People and the National Museum of China. The square is a symbol of China&apos;s political and cultural identity.
          </p>
          <p>
            <img
              src="./images/beijing/tiananmen.jpg"
              alt="Tiananmen Square"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Temple of Heaven">The Temple of Heaven</h4>
          <p align="justify">
The Temple of Heaven is a stunning example of Chinese religious architecture, where emperors of the Ming and Qing dynasties performed rituals to pray for good harvests. The park surrounding the temple is a peaceful retreat, popular among locals for morning exercises and leisure activities. Its harmonious design reflects ancient Chinese beliefs in the connection between heaven and earth.
          </p>
          <p>
            <img
              src="./images/beijing/tiantan.jpg"
              alt="The Temple of Heaven"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Summer Palace">The Summer Palace</h4>
          <p align="justify">
The Summer Palace, a masterpiece of Chinese landscape garden design, is a vast ensemble of lakes, gardens, and palaces. It served as a luxurious retreat for emperors to escape the summer heat. The Kunming Lake and Longevity Hill offer serene views, making it a perfect spot for relaxation and appreciation of traditional Chinese aesthetics.
          </p>
          <p>
            <img
              src="./images/beijing/yiheyuan.jpg"
              alt="The Summer Palace"
              width="100%"
            />
          </p>
          <hr></hr>
          <h4 id="The Old Summer Palace">The Old Summer Palace</h4>
          <p align="justify">
The Old Summer Palace, also known as Yuanmingyuan, was once a grand imperial garden complex. Although largely destroyed during the Second Opium War, its ruins remain a poignant reminder of China&apos;s past glory and the impact of foreign invasions. The site is a blend of natural beauty and historical significance.          </p>
          <p>
            <img
              src="./images/beijing/yuanmingyuan.jpg"
              alt="The Old Summer Palace"
              width="100%"
            />
          </p>

          <h4 id="Yonghe Temple">Yonghe Temple</h4>
          <p align="justify">
Yonghe Temple, also known as the Lama Temple, is one of the largest and most important Tibetan Buddhist monasteries in the world. Its stunning architecture, intricate carvings, and serene atmosphere make it a spiritual haven in the bustling city of Beijing. Visitors can experience the rich cultural heritage of Tibetan Buddhism here.
          </p>  
          <p>
            <img
              src="./images/beijing/yonghegong.jpg"
              alt="Yonghe Temple"
              width="100%"
            />
          </p>


          
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
  }
  else {
    return (
      <React.Fragment>
      <SEO title="Scenery | DMBD 2025" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Scenery"
        content="For Participants"
        contentTwo="Scenery"
        linkage="/"

      />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h3>To be released.</h3>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Scenery;
